<!-- <script></script> -->

<template>
	<!-- footer -->
	<footer><span>한국녹색기후기술원</span> Copyright 2023. KBeT. all rights reserved.</footer>
</template>
  